import styled from "styled-components";
import {breakpoints} from "../../../../../theme";

export const SharePointConfigurationFormWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;

    @media (max-width: ${breakpoints.mdPlus}) {
        flex-direction: column-reverse;
    }
`;

export const StyledFormButtons = styled.div`
    display: flex;
    gap: 8px;
    flex-shrink: 0;

    @media (max-width: ${breakpoints.mdPlus}) {
        margin-bottom: 16px;
        align-self: stretch;
        justify-content: space-between;
    }
`;

export const StyledFormFields = styled.div`
    flex: 1;
    min-width: 0;
`;